import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { InputMui } from '../../../../../../components/input-mui/input-mui';
import { ROUTES } from '../../../../../../routes/routes';
import { patterns } from '../../../../../../utils/validation';

type GroupNameProps = {
  errorMessage?: string;
};

const GroupName: React.FC<GroupNameProps> = ({ errorMessage = '' }) => {
  const { control } = useFormContext();
  const { t } = useTranslation('groups');
  const { t: tc } = useTranslation('common');
  const { pathname } = useLocation();

  return (
    <Controller
      name="name"
      control={control}
      rules={{
        required: tc('isRequired') as string,
        maxLength: {
          value: 40,
          message: tc('tooLongName'),
        },
        pattern: {
          value: patterns.name,
          message: tc('invalidName'),
        },
      }}
      render={({ field, fieldState: { error } }) => (
        <InputMui
          label={t('name')}
          name={field.name}
          value={field.value}
          autoFocus={pathname === ROUTES.GroupCreate()}
          onChange={field.onChange}
          errorMessage={error?.message || errorMessage}
          clearEnabled
        />
      )}
    />
  );
};

export default GroupName;
